// Mobile Carousel Navigation
(function() {
  console.log('Mobile carousel JS file loaded');
  
  // Define global navigation function
  window.mobileCarouselNav = function(carouselId, action) {
    console.log('mobileCarouselNav called with:', carouselId, action);
    
    var container = document.getElementById(carouselId);
    console.log('Container found:', container);
    
    if (!container) {
      console.log('Carousel container not found:', carouselId);
      return;
    }
    
    var scroller = container.querySelector('slideshow-slides');
    var slides = container.querySelectorAll('slideshow-slide');
    console.log('Scroller:', scroller);
    console.log('Slides found:', slides.length);
    
    var mobileNav = document.querySelector('[data-carousel-target="' + carouselId + '"]');
    var dots = mobileNav ? mobileNav.querySelectorAll('.slideshow-mobile-nav__dot') : [];
    
    if (!scroller || slides.length === 0) {
      console.log('Scroller or slides not found');
      return;
    }
    
    var totalSlides = slides.length;
    var currentIndex = parseInt(container.getAttribute('data-current-index') || '0');
    console.log('Current index:', currentIndex);
    
    var newIndex;
    if (action === 'prev') {
      newIndex = currentIndex - 1;
      if (newIndex < 0) newIndex = totalSlides - 1;
    } else if (action === 'next') {
      newIndex = currentIndex + 1;
      if (newIndex >= totalSlides) newIndex = 0;
    } else {
      newIndex = parseInt(action);
    }
    
    console.log('New index:', newIndex);
    container.setAttribute('data-current-index', newIndex);
    
    var slideWidth = scroller.offsetWidth;
    var scrollTarget = newIndex * slideWidth;
    console.log('Slide width:', slideWidth, 'Scroll target:', scrollTarget);
    
    scroller.scrollTo({
      left: scrollTarget,
      behavior: 'smooth'
    });
    
    // Update dots
    for (var i = 0; i < dots.length; i++) {
      if (i === newIndex) {
        dots[i].classList.add('slideshow-mobile-nav__dot--active');
      } else {
        dots[i].classList.remove('slideshow-mobile-nav__dot--active');
      }
    }
  };
  
  // Event delegation
  document.addEventListener('click', function(e) {
    var button = e.target.closest('[data-action]');
    if (!button) return;
    
    var mobileNav = button.closest('.slideshow-mobile-nav');
    if (!mobileNav) return;
    
    var carouselId = mobileNav.getAttribute('data-carousel-target');
    if (!carouselId) return;
    
    console.log('Click detected, carouselId:', carouselId);
    
    var action = button.getAttribute('data-action');
    
    if (action === 'prev' || action === 'next') {
      window.mobileCarouselNav(carouselId, action);
    } else if (action === 'goto') {
      var slideIndex = button.getAttribute('data-slide-index');
      window.mobileCarouselNav(carouselId, slideIndex);
    }
  });
  
  console.log('Mobile carousel nav initialized');
})();
